module.exports = __webpack_public_path__ + "img/iphone-x.da52134f.svg";